export default __webpack_public_path__ + "static/media/glucerna400.7d041df4.jpg";